module.exports = __webpack_public_path__ + "img/e0c4957.png";